import app from '../../app';

export default {
  notify(data) {
    app.trigger('collaboration:notify', data);
  },
};
